import { JSW_TMP_BACKLOG_BOARD_REGEXP } from '../../common/constants';

export const shouldDisableGICFlagCreation: () => boolean = () =>
	JSW_TMP_BACKLOG_BOARD_REGEXP.test(window.location.pathname);
